import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, mapTo } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { Details } from '@details/Interfaces/details';
import { UdfGroupResponseResult, UdfGroup } from '@feature/_app_modules/additional-information/models/UdfGroups';
import { AdditionalInformationByKeyRequest, AdditionalInformationDetailsResponse, SaveAdditionalInformationUserSelectedSectionsRequest, AvailableGroupsRequest, AdditionalInformationRequest } from '../additional-information.types';

@Injectable({
  providedIn: 'root'
})

export class AdditionalInformationHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlProvider: UrlBuilderService) { }

  getAvailableGroups(request: AvailableGroupsRequest): Observable<UdfGroup[]> {
    const url = this.urlProvider.getUrl(`additional-information/available-groups`);

    return this.http.post<UdfGroupResponseResult>(url, request).pipe(map((response) => {
      return response.Groups;
    }));
  }

  getUserSelectedGroups(request: AdditionalInformationRequest): Observable<UdfGroup[]> {
    const url = this.urlProvider.getUrl(`additional-information/user-selected-sections`);

    return this.http.post<UdfGroupResponseResult>(url, request).pipe(map((response) => {
      return response.Groups;
    }));
  }

  getAdditionalInformation(request: AdditionalInformationRequest): Observable<Details> {
    const url = this.urlProvider.getUrl(`additional-information`);
    
    return this.http.post<AdditionalInformationDetailsResponse>(url, request).pipe(map(details => details.AdditionalInformation || undefined));
  }

  getAdditionalInformationByKey(request: AdditionalInformationByKeyRequest): Observable<Details> {
    const url = this.urlProvider.getUrl(`additional-information/by-key`);

    return this.http.post<AdditionalInformationDetailsResponse>(url, request).pipe(map(details => details.AdditionalInformation || undefined));
  }

  saveAdditionalInformationUserSections(request: SaveAdditionalInformationUserSelectedSectionsRequest): Observable<boolean> {
    const url = this.urlProvider.getUrl(`additional-information/sections`);

    return this.http.post(url, request).pipe(mapTo(true));
  }

  setToDefaults(request: AdditionalInformationRequest): Observable<boolean> {
    const url = this.urlProvider.getUrl(`additional-information/default`);

    return this.http.post(url, request).pipe(mapTo(true));
  }
}
